import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';
import { useAtomValue, useSetAtom } from 'jotai';
import { productsManagementFiltersAtom } from 'atoms/filters/products-management-filters.ts';
import {
  mapProductManagementFiltersToURLSearchParams,
  mapURLSearchParamsToProductManagementFilters,
} from '@/activityLog/productsManagement/Filters/utils/filtersToURLSearchParamsMapper.ts';

export const ProductManagementFiltersURLParser = ({ children }: { children: React.ReactNode }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const setFilters = useSetAtom(productsManagementFiltersAtom);
  const isMounted = useRef(false);

  const filters = useAtomValue(productsManagementFiltersAtom);

  useEffect(() => {
    if (isMounted) {
      setSearchParams(mapProductManagementFiltersToURLSearchParams(filters), { replace: true });
    }
  }, [filters]);

  if (!isMounted.current) {
    setFilters(mapURLSearchParamsToProductManagementFilters(searchParams));
    isMounted.current = true;
  }

  return <>{children}</>;
};
